module.exports = __webpack_public_path__ + "c5330aaa5ee12e76fd844eb3004656f7.svg";


//////////////////
// WEBPACK FOOTER
// ../app_shared/assets/images/tos_signature.svg
// module id = 822
// module chunks = 0